import confirmation from "../../assets/images/confirmation.png";

export const CancelSubscriptionConfirmation = ({
  leftButton,
  rightButton,
  onclick,
  title,
  des,
  des2,
  handleCancelSubscription,
}) => {
  const contentHTML = { __html: des2 };
  return (
    <div className="mx-auto py-2 relative pb-2">
      <img
        src={confirmation}
        className="mx-auto sm:w-[150px] pb-2"
        alt="payment-successful"
      />
      <h2 className="text-f20 font-extrabold">{title}</h2>
      <p className="text-secondary pt-2 pb-4 w-96 text-f14">{des}</p>
      <p
        className="text-secondary pt-2 pb-4 w-96 text-f14"
        dangerouslySetInnerHTML={contentHTML}
      />
      <hr />
      <br />
      <div className="flex gap-5">
        <button
          onClick={onclick}
          className="text-link bg-white rounded  px-4 py-2  border border-link text-f14 font-semibold w-full"
        >
          {leftButton}
        </button>
        <button
          onClick={handleCancelSubscription}
          className="bg-primary px-2 py-3 text-white text-f14 font-semibold rounded w-full"
        >
          {rightButton}
        </button>
      </div>
    </div>
  );
};
